export default __webpack_public_path__ + "static/media/email.0f1bbb29.svg";